import { Http } from "@/net/Http";
import { Urls } from "@/net/Urls";
import wx, { JSApis, ConfigOptions } from "weixin-js-sdk";
import { openToast } from "toast-ts";

export interface WXShareConfig {
  appId: string;
  nonceStr: string;
  signature: string;
  timestamp: number;
}

export interface WXShareOpstion {
  title: string;
  link: string;
  imgUrl: string;
  dec: string;
}
export class WXShare {
  static wxShareData(
    opstion: WXShareOpstion,
    success: Function,
    err:Function
  ) {
    const location = window.location.origin + window.location.pathname;
    Http.post<WXShareConfig>(Urls.getJssdkConfig, {
      url: location
    }).then(
      (res: WXShareConfig) => {
        this.shareConfig(res);
        wx.ready(function() {
          WXShare.shareTimeline(opstion, success, location);
          WXShare.shareAppeMessage(opstion, success, location);
        });
      },
      (e: string) => {
        err();
        // console.log("WXApi:", e);
      }
    );
  }

  static shareConfig(cofig: WXShareConfig) {
    const apiList: JSApis[] = [
      "updateAppMessageShareData",
      "updateTimelineShareData",
      "onMenuShareTimeline",
      "onMenuShareAppMessage"
    ];
    const con: ConfigOptions = {
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: cofig.appId, // 必填，公众号的唯一标识
      timestamp: cofig.timestamp.toString(), // 必填，生成签名的时间戳
      nonceStr: cofig.nonceStr, // 必填，生成签名的随机串
      signature: cofig.signature, // 必填，签名
      beta: true,
      jsApiList: apiList, // 必填，需要使用的JS接口列表
      openTagList: ['wx-open-launch-weapp'] // 跳转小程序
    };
    wx.config(con);
  }

  static shareAppeMessage(
    opstion: WXShareOpstion,
    success: Function,
    location: string
  ) {
    wx.ready(function() {
      wx.onMenuShareAppMessage({
        title: opstion.title, // 分享标题
        link: location,
        imgUrl: opstion.imgUrl, // 分享图标
        desc: opstion.dec, // 分享描述
        success: () => {
          // 设置成功
          openToast("分享成功");
          success();
        }
      });
    });
  }

  static shareTimeline(
    opstion: WXShareOpstion,
    success: Function,
    location: string
  ) {
    wx.ready(function() {
      wx.onMenuShareTimeline({
        title: opstion.title, // 分享标题
        link: location,
        imgUrl: opstion.imgUrl, // 分享图标
        success: () => {
          openToast("分享成功");
          success();
        }
      });
    });
  }
}
